import React$1 from 'react';

const LeftArrow = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "39",
  height: "39",
  viewBox: "0 0 39 39"
}, /*#__PURE__*/React$1.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FF005F",
  strokeWidth: "2",
  transform: "matrix(-1 0 0 1 39 .5)"
}, /*#__PURE__*/React$1.createElement("ellipse", {
  cx: "19.5",
  cy: "19",
  rx: "18.5",
  ry: "18"
}), /*#__PURE__*/React$1.createElement("path", {
  strokeLinecap: "square",
  d: "M24 19.5l-7 7m7-7l-7-7"
})));

export default LeftArrow;
